export const getCurrentRouteSamplingRate = () => 100;
export const isAutomaticExposureCollectionEnabled = () => true;
